import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontMedium } from 'src/styles/font';

export const tabContainerStyle = css`
  display: flex;
  flex-direction: column;
  background: ${colors.primaryBgColor};
  align-items: center;
  padding: 10px;
`;

export const tabHeaderStyle = css`
  width: 100%;
  max-width: 640px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const tabButtonStyle = css`
  width: 100%;
  text-align: center;
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${colors.white};
  ${ZeeFontMedium(14, 20)}
  cursor: pointer;
  font-style: normal;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;

export const tabButtonActiveStyle = css`
  border-bottom: 2px solid ${colors.white};
`;

export const contentAreaStyle = css`
  width: 100%;
  max-width: 640px;
  color: ${colors.white};
  font-size: 16px;
`;

export const contestWrapperStyle = css`
  margin-bottom: 20px;
`;

export const winningPrizeImageStyle = css`
  width: 100%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 20px;
`;
